import React from 'react';
import CustomContextPopup from '../../../components/CustomContextPopup';
import PublishPopup from '../../../components/PublishPopup';
import EditorialChangePopup from '../../../components/EditorialChangePopup';
import ContentChangePopup from '../../../components/ContentChangePopup';
import DetailsPopup from '../../../components/DetailsPopup';
import ExistingModelPopup from '../../../components/ExistingModelPopup';
import ExistingRolePopup from '../../../components/ExistingRolePopup';
import TextInputModal from '../../../components/TextInputModal';
import TranslationPopup from '../../../hooks/TranslationPopup';
import VersionPopup from '../../../components/VersionPopup';
import VersionPopupView from '../../../components/VersionPopupView';
import ManageRoleGroupModal from './ManageRoleGroupModal';
import AssignRoleOwnerModal from './AssignRoleOwnerModal';
import EditScheduledPublishingModal from '../../../components/EditScheduledPublishingModal';
import RequestChangeModal from '../../../components/RequestChangeModal';
import AddObjectRole from '../../../all-node/swimlane-nodes/AddObjectRole';

export const SwimlaneModals = ({
  activeMode,
  // Menu visibility/Context
  MenuVisible,
  contextMenu,
  menuItems,
  handlers,
  // Publish
  showPublishPopup,
  setShowPublishPopup,
  responseData,
  processDefaultlanguage_id,
  supportedLanguages,
  OriginalDefaultlanguge_id,
  // Editorial
  showEditorialPopup,
  setShowEditorialPopup,
  // Content
  showContentPopup,
  setShowContentPopup,
  // Details
  isPopupOpen,
  setIsPopupOpen,
  selectedNodeId,
  setSelectedNodeId,
  ChildNodes,
  // Existing Model
  isCheckboxPopupOpen,
  t,
  popupStyle,
  styles,
  searchQuery,
  setSearchQuery,
  filteredData,
  selectedLinknodeIds,
  // Existing Role
  isexistingroleCheckboxPopupOpen,
  ExistingrolesearchQuery,
  setExistingrolesearchQuery,
  filteredDataExistingrole,
  selectedexistigrolenodeId,
  // Text Input
  isModalOpen,
  setIsModalOpen,
  modalText,
  // Add Object Role
  options,
  position,
  // Translation
  showTranslationPopup,
  setShowTranslationPopup,
  translationDefaults,
  // Version Popup
  showVersionPopup,
  setShowVersionPopup,
  id,
  currentLevel,
  currentParentId,
  LoginUser,
  headerTitle,
  versionPopupPayload,
  // Manage Role Group
  showRoleGroupModal,
  setShowRoleGroupModal,
  setRoleGroupEditData,
  roleGroupEditData,
  langMap,
  parsedDataExistingrole,
  assignedUsers,
  setChiledNodes,
  setHasUnsavedChanges,
  // Assign Role Owner
  showAssignOwnerModal,
  setShowAssignOwnerModal,
  activeRoleForOwner,
  // Approvals (Draft)
  editScheduledModalOpen,
  setEditScheduledModalOpen,
  pendingApproval,
  handleCancelPublishing,
  handleReschedulePublishing,
  requestChangeModalOpen,
  setRequestChangeModalOpen,
  handleContentChangeRequest,
  // Version View Props
  contactInfo,
  revisionInfo,
}) => {
  return (
    <>
      {activeMode === 'edit' && (
        <>
          <CustomContextPopup
            isVisible={!!MenuVisible}
            position={contextMenu || { x: 0, y: 0 }}
            menuItems={menuItems}
            onClose={handlers.handleClosePopup}
          />

          <PublishPopup
            isOpen={showPublishPopup}
            onClose={() => setShowPublishPopup(false)}
            onNext={handlers.handleNext}
            revisionresponse={responseData}
            selectedLanguage={processDefaultlanguage_id}
            supportedLanguages={supportedLanguages}
          />

          <EditorialChangePopup
            isOpen={showEditorialPopup}
            onBack={() => {
              setShowEditorialPopup(false);
              setShowPublishPopup(true);
            }}
            onPublish={handlers.editorialPublish}
          />

          <ContentChangePopup
            isOpen={showContentPopup}
            type={'Swimlane'}
            onBack={() => {
              setShowContentPopup(false);
              setShowPublishPopup(true);
            }}
            onStartApproval={handlers.handleContentSubmit}
            revisionresponse={responseData}
            versionPopupPayload={versionPopupPayload}
            supportedLanguages={supportedLanguages}
            selectedLanguage={processDefaultlanguage_id}
          />

          <DetailsPopup
            className="detailspopup_swimlane"
            isOpen={isPopupOpen}
            onClose={() => {
              setIsPopupOpen(false);
              setSelectedNodeId(null);
            }}
            onSave={handlers.saveDetails}
            Details={
              ChildNodes.find(
                (node) => node.node_id === selectedNodeId || node.id === selectedNodeId
              ) || null
            }
            supportedLanguages={supportedLanguages}
            selectedLanguage={processDefaultlanguage_id}
          />

          <ExistingModelPopup
            isOpen={isCheckboxPopupOpen}
            t={t}
            popupStyle={popupStyle}
            styles={styles}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            filteredData={filteredData}
            selectedId={selectedLinknodeIds}
            onCheckboxChange={handlers.handleCheckboxChange}
            onSave={handlers.saveSelectedNodes}
          />

          <ExistingRolePopup
            isOpen={isexistingroleCheckboxPopupOpen}
            t={t}
            popupStyle={popupStyle}
            styles={styles}
            searchQuery={ExistingrolesearchQuery}
            setSearchQuery={setExistingrolesearchQuery}
            data={filteredDataExistingrole}
            selectedId={selectedexistigrolenodeId}
            onSelect={handlers.handleexistingroleCheckboxChange}
            onSave={handlers.handleSaveExistingRole}
          />

          <TextInputModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            onSubmit={handlers.handleTextSubmit}
            initialValue={modalText}
          />

          {options.length > 0 && (
            <AddObjectRole
              position={position}
              options={options}
              onOptionClick={handlers.handleOptionClick}
              onClose={() => setIsPopupOpen(false)}
            />
          )}

          <TranslationPopup
            isOpen={showTranslationPopup}
            onClose={() => setShowTranslationPopup(false)}
            defaultValues={translationDefaults}
            supportedLanguages={supportedLanguages}
            onSubmit={(values) => {
              const node = ChildNodes.find((n) => n.id === selectedNodeId);
              if (node) {
                handlers.updateNodeTranslations(node.id, values);
              }
              setShowTranslationPopup(false);
            }}
          />

          {showVersionPopup && (
            <VersionPopup
              processId={id}
              currentLevel={currentLevel}
              onClose={() => setShowVersionPopup(false)}
              currentParentId={currentParentId}
              viewVersion={handlers.navigateToVersion}
              LoginUser={LoginUser}
              title={headerTitle}
              handleSaveVersionDetails={handlers.handleSaveVersionDetails}
              status={'draft'}
              versionPopupPayload={versionPopupPayload}
              supportedLanguages={supportedLanguages}
              type="Swimlane"
              selectedLanguage={processDefaultlanguage_id}
            />
          )}

          <ManageRoleGroupModal
            isOpen={showRoleGroupModal}
            onClose={() => {
              setShowRoleGroupModal(false);
              setRoleGroupEditData(null);
            }}
            onSave={handlers.handleSaveRoleGroup}
            initialData={roleGroupEditData}
            supportedLanguages={supportedLanguages}
            langMap={langMap}
            existingRoles={parsedDataExistingrole.map((exRole) => {
              const baseId = exRole.node_id || exRole.id;
              const liveRole = ChildNodes.find(
                (cn) => (cn.id === baseId || cn.data?.link === baseId) && !cn.data?.isRoleGroup
              );
              if (liveRole) {
                return {
                  ...exRole,
                  data: {
                    ...exRole.data,
                    owner: liveRole.data?.owner || exRole.data?.owner,
                    translations: {
                      ...(exRole.data?.translations || {}),
                      ...(liveRole.data?.translations || {}),
                    },
                    details: {
                      ...(exRole.data?.details || {}),
                      title: liveRole.data?.details?.title || exRole.data?.details?.title,
                    },
                  },
                };
              }
              return exRole;
            })}
            allUsers={assignedUsers}
            selectedLanguage={processDefaultlanguage_id}
            onUpdateRoleTranslations={(roleId, values) =>
              handlers.updateNodeTranslations(roleId, values)
            }
            onUpdateRoleOwner={(roleId, ownerUser) => {
              const activeRole = ChildNodes.find((n) => n.id === roleId || n.data?.link === roleId);
              if (activeRole) {
                const baseId = activeRole.data?.link || activeRole.id;
                setChiledNodes((prev) =>
                  prev.map((n) => {
                    const isMatch = n.id === baseId || n.data?.link === baseId || n.id === roleId;
                    if (isMatch && n.type === 'SwimlineRightsideBox' && !n.data?.isRoleGroup) {
                      return { ...n, data: { ...n.data, owner: ownerUser } };
                    }
                    if (n.data?.isRoleGroup && n.data?.roles) {
                      const updatedRoles = n.data.roles.map((r) =>
                        r.id === baseId ? { ...r, owner: ownerUser } : r
                      );
                      return { ...n, data: { ...n.data, roles: updatedRoles } };
                    }
                    return n;
                  })
                );
                setHasUnsavedChanges(true);
              }
            }}
            onCreateRole={handlers.handleCreateRole}
          />

          <AssignRoleOwnerModal
            isOpen={showAssignOwnerModal}
            onClose={() => setShowAssignOwnerModal(false)}
            onAssign={(user) => {
              if (!activeRoleForOwner) return;
              const baseId = activeRoleForOwner.data?.link || activeRoleForOwner.id;
              setChiledNodes((prev) =>
                prev.map((n) => {
                  const isMatch =
                    n.id === baseId || n.data?.link === baseId || n.id === activeRoleForOwner.id;
                  if (isMatch && n.type === 'SwimlineRightsideBox' && !n.data?.isRoleGroup) {
                    return { ...n, data: { ...n.data, owner: user } };
                  }

                  if (n.data?.isRoleGroup && n.data?.roles) {
                    const updatedRoles = n.data.roles.map((r) =>
                      r.id === baseId ? { ...r, owner: user } : r
                    );
                    return { ...n, data: { ...n.data, roles: updatedRoles } };
                  }

                  return n;
                })
              );
              setHasUnsavedChanges(true);
            }}
            initialOwner={activeRoleForOwner?.data?.owner}
            users={assignedUsers}
          />
        </>
      )}

      {showVersionPopup && activeMode !== 'edit' && (
        <VersionPopupView
          processId={id}
          currentLevel={currentLevel}
          currentParentId={currentParentId}
          onClose={() => setShowVersionPopup(false)}
          viewVersion={handlers.navigateToVersion}
          LoginUser={LoginUser}
          title={headerTitle}
          type="Swimlane"
          selectedLanguage={processDefaultlanguage_id}
          OriginalDefaultlanguge_id={OriginalDefaultlanguge_id || undefined}
          contact_info={contactInfo || undefined}
          revision_info={revisionInfo || undefined}
          assigned_users={assignedUsers || []}
          status={activeMode === 'published' ? 'Published' : 'draft'}
          hideVersionTab={activeMode === 'version'}
        />
      )}

      {activeMode === 'draft' && (
        <>
          <EditScheduledPublishingModal
            isOpen={editScheduledModalOpen}
            onClose={() => setEditScheduledModalOpen(false)}
            currentDate={pendingApproval?.approval?.planned_publish_date}
            onCancelPublishing={handleCancelPublishing}
            onReschedulePublishing={handleReschedulePublishing}
          />
          <RequestChangeModal
            isOpen={requestChangeModalOpen}
            onClose={() => setRequestChangeModalOpen(false)}
            onSubmit={handleContentChangeRequest}
          />
        </>
      )}
    </>
  );
};
